// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__3crQ6","notes":"Notes_notes__17GEY","note":"Notes_note__cbLLc","markdown":"Notes_markdown__1kQG8"};